import { JSONSchema7 } from "json-schema";

export const createLimitEditorSchema: JSONSchema7 = {
  type: "object",
  required: ["property", "limit"],
  properties: {
    property: {
      type: "string",
      title: "Formularfeld, welches limitiert werden soll"
    },
    limit: {
      type: "number",
      title: "Anzahl der verfügbaren Plätze"
    },
    price: {
      type: "number",
      title: "Preis"
    }
  }
};
